import { Listbox, ListboxOption } from '@/components/base/listbox'

interface Props {
  value: number
  onChange: (value: number) => void
}

export const Selector = ({ value, onChange }: Props) => {
  return (
    <Listbox value={value} onChange={onChange}>
      { [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(option => (
        <ListboxOption key={option} value={option}>
          { option }
        </ListboxOption>
      )) }
    </Listbox>
  )
}
